import React from "react";
import srcAddWhite from "../styles/img/add-white.svg";
import Img from "react-image";

const AddButton = (props) => {
  return (
    <Img
      className="img-fluid"
      onClick={props.onClick}
      src={srcAddWhite}
      style={{ width: "16px", height: "16px" }}
    />
  );
};

export default AddButton;
